function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _dec, _dec2, _dec3, _dec4, _class, _class2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

import { Brick } from "zengular";
import twig from "./magic-form-wrapper.twig";
import "./magic-form-wrapper.scss";
import magic from "../modules/magic";
import { ZengularNotification } from "zengular-ui";
/**
 * @property {Object} tabView
 */

var MagicFormWrapperBrick = (_dec = Brick.register('magic-form-wrapper', twig), _dec2 = Brick.addClass('form'), _dec3 = Brick.renderOnConstruct(false), _dec4 = Brick.listen(magic.event.save), _dec(_class = _dec2(_class = _dec3(_class = (_class2 = /*#__PURE__*/function (_Brick) {
  _inherits(MagicFormWrapperBrick, _Brick);

  var _super = _createSuper(MagicFormWrapperBrick);

  function MagicFormWrapperBrick() {
    _classCallCheck(this, MagicFormWrapperBrick);

    return _super.apply(this, arguments);
  }

  _createClass(MagicFormWrapperBrick, [{
    key: "onInitialize",
    value: function onInitialize() {
      this.head = {};
      this.item = {};
    }
  }, {
    key: "setup",
    value: function setup(data) {
      this.id = data.id;
      this.handler = magic.getHandler(data.handler);
      this.load(this.id);
    }
  }, {
    key: "createViewModel",
    value: function createViewModel() {
      return {
        handler: this.handler,
        head: this.head,
        item: this.item,
        id: this.id
      };
    }
  }, {
    key: "id",
    get: function get() {
      return this._id;
    },
    set: function set(id) {
      this._id = id;
    }
  }, {
    key: "label",
    get: function get() {
      return this.id;
    }
  }, {
    key: "guid",
    get: function get() {
      return this.item.guid ? this.item.guid : null;
    }
  }, {
    key: "init",
    value: function init(id, item) {
      return {
        id: this.id,
        label: this.label,
        guid: this.guid
      };
    }
  }, {
    key: "load",
    value: function load(id) {
      var _this = this;

      var fetch = id === null ? this.handler.fetch.blank() : this.handler.fetch.get(id);
      return fetch.then(function (res) {
        return res.json();
      }).then(function (data) {
        _this.id = data.id;
        _this.item = data.item;
        _this.attributes = data.attributes;
        _this.head = _this.init(_this.id, _this.item);
        _this.tab.dataset.tabId = _this.handler.createId(_this.id);
        _this.tab.label = _this.head.id ? 'id: ' + _this.head.id : 'new';
        _this.tab.title = _this.head.label ? _this.head.label : _this.handler.translate('label.form');
        _this.tab.icon = _this.handler.translate('icon.small', 'fad fa-rocket');
      }).then(function () {
        return _this.render();
      }).then(function () {
        return _this.$$('form-body').brick.setup(_this.item, _this.attributes);
      });
    }
  }, {
    key: "onRender",
    value: function onRender() {
      var _this2 = this;

      this.buttons.forEach(function (button) {
        var btn;
        button.create('div', false).then(function (btn) {
          btn.form = _this2;

          _this2.$$('nav').node.append(btn.root);

          btn.render();
        });
      });
      return this.form.create('div', false, {
        handler: this.handler.name
      }).then(function (form) {
        form.actor('form-body');

        _this2.root.appendChild(form.root);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
      return _get(_getPrototypeOf(MagicFormWrapperBrick.prototype), "render", this).call(this, args);
    }
  }, {
    key: "remove",
    value: function remove() {
      this.tab.remove();
    }
  }, {
    key: "__save",
    value: function __save(event) {
      var _this3 = this;

      this.$$('form-body').brick.clearErrors();
      var data = this.$$('form-body').brick.data;
      if (!(data instanceof Promise)) data = Promise.resolve(data);
      data.catch(function (errors) {
        errors.forEach(function (error) {
          ZengularNotification.show(ZengularNotification.style.danger, 'fas fa-exclamation-triangle', "<b>".concat(error.as, "</b><br>").concat(error.message));

          _this3.$$('form-body').brick.error(error.as, error.message);
        });
        throw 'error';
      }).then(function (data) {
        return _this3.id ? _this3.handler.fetch.save(_this3.id, data) : _this3.handler.fetch.create(data);
      }).then(function (res) {
        if (res.status === 200) {
          res.json().then(function (data) {
            return _this3.load(data.id);
          }).then(function () {
            return _this3.fire(magic.event.itemChanged, {
              handler: _this3.handler.name
            });
          }).then(function () {
            return ZengularNotification.show(ZengularNotification.style.success, 'fas fa-thumbs-up', 'Item saved');
          });
        } else {
          res.json().then(function (errors) {
            errors.forEach(function (error) {
              ZengularNotification.show(ZengularNotification.style.danger, 'fas fa-exclamation-triangle', "<b>".concat(error.field, "</b><br>").concat(error.message));

              _this3.$$('form-body').brick.error(error.field, error.message);
            });
          });
        }
      }).catch(function () {});
    }
  }]);

  return MagicFormWrapperBrick;
}(Brick), (_applyDecoratedDescriptor(_class2.prototype, "__save", [_dec4], Object.getOwnPropertyDescriptor(_class2.prototype, "__save"), _class2.prototype)), _class2)) || _class) || _class) || _class);
export { MagicFormWrapperBrick as default };